document.addEventListener("DOMContentLoaded",function(){
    

  // YG Video Reviews
  var YGSwiperStyle1 = class extends HTMLElement {
    constructor() {
        super();
        this.loadScript();
    }

    loadScript(event) {
        if(this.getAttribute("data-request-design") ){
            let loadScript = document.createElement("script");
            loadScript.src = this.getAttribute("data-load-script");
            document.body.appendChild(loadScript);
            
            loadScript.onload = () => {
                this.swiper()
            }
        }else{
            this.swiper()
        }
    }

    swiper(){
        let swiperItem = this.querySelector('.swiper.swiper-style1')
        console.log(swiperItem)
        if(!swiperItem) return

        let swiperItemCount = swiperItem.getAttribute("data-item-count") ? swiperItem.getAttribute("data-item-count") : 4
        let swiperItemGap = swiperItem.getAttribute("data-item-gap") ? swiperItem.getAttribute("data-item-gap") : 24
        let slidesPerView = 0;
        if(this.getAttribute("data-PerView")) {
          slidesPerView = Number(this.getAttribute("data-PerView"))
        } else {
          slidesPerView = 1.2

        }
        new Swiper(swiperItem, {
            slidesPerView: slidesPerView,
            spaceBetween: 15,
            breakpoints: {
              //当宽度大于等于768
              768: {
                slidesPerView: swiperItemCount * 0.8,
                spaceBetween: swiperItemGap * 0.8
              },
              //当宽度大于等于1280
              1280: {
                slidesPerView: swiperItemCount,
                spaceBetween: swiperItemGap
              },
              //当宽度大于等于1680
              1680: {
                slidesPerView: swiperItemCount * 1.1,
                spaceBetween: swiperItemGap * 1.1
              }
            },
            scrollbar: {
              el: ".swiper-scrollbar",
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }
        })
    }
  }

  if (!window.customElements.get("yg-swiper-style1")){
    window.customElements.define("yg-swiper-style1", YGSwiperStyle1);
  } 

  // YG image link
  var YGImageLink = class extends HTMLElement {
    constructor() {
        super();
        this.loadScript();
    }

    loadScript(event) {
        if(this.getAttribute("data-request-design") ){
            let loadScript = document.createElement("script");
            loadScript.src = this.getAttribute("data-load-script");
            document.body.appendChild(loadScript);
            
            loadScript.onload = () => {
                this.swiper()
            }
        }else{
            this.swiper()
        }
    }

    swiper(){
        let swiperItem = this.querySelector('.swiper')
        console.log(swiperItem)
        if(!swiperItem) return

        let swiperItemCount = swiperItem.getAttribute("data-item-count") ? swiperItem.getAttribute("data-item-count") : 4
        let swiperItemGap = swiperItem.getAttribute("data-item-gap") ? swiperItem.getAttribute("data-item-gap") : 24
        
        new Swiper(swiperItem, {
            slidesPerView: 1.5,
            spaceBetween: 15,
            breakpoints: {
              //当宽度大于等于768
              768: {
                slidesPerView: swiperItemCount,
                spaceBetween: swiperItemGap
              },
            },
            scrollbar: {
              el: ".swiper-scrollbar",
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }
        })
    }
  }

  if (!window.customElements.get("yg-image-link-block")){
    window.customElements.define("yg-image-link-block", YGImageLink);
  } 
})


